module.exports = __webpack_public_path__ + "static/media/lab51Demo-512.f8ea67d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lab51Demo-512.png
// module id = 761
// module chunks = 0